import React, { useState, useEffect } from "react";
import "../roleManagement/RoleManagement.scss";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import useForm from "./useForm";
import { isRequired } from "../../utils/Validate";

const ViewRole = () => {
  const {
    parentMenuList,
    values,
    setValues,
    subMenuList,
    setSubMenuList,
    menuList,
    handleFormChange,
    errors,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    selectedParent,
    setSelectedParent,
    handleStatusChange,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    loading,
    setLoading,
    setErrors,
  } = useForm();

  const handleCheck = (e, index) => {
  };

  useEffect(() => {
    if (values?.id) {
      const userRoles = values?.role?.map((c) => ({
        ...c,
        menuName:
          subMenuList?.find((obj) => obj?.id === c?.menuId)?.menuName || "",
        menuParentId:
          subMenuList?.find((obj) => obj?.id === c?.menuId)?.menuParentId || "",
      }));

      const roles = userRoles?.filter(
        (ob) => ob?.menuParentId == selectedParent
      );

      setValues({
        ...values,
        rolePermissions: roles,
      });
    }
  }, [selectedParent, subMenuList]);

  return (
    <div className="container-fluid view-role-sec">
      <section className="role-view-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-xs-12">
                    <div>
                      <label>
                        Role Name <span className="mandatory">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="roleName"
                        placeholder="Enter role name"
                        onChange={handleFormChange}
                        value={values?.roleName}
                        disabled={true}
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <label>Applicable only to distributor</label>
                    <div className="form-group mb-0 mt-2">
                      <input
                        type="checkbox"
                        id="applicable"
                        name="applicable"
                        value={values?.onlyForDistributor}
                        checked={values?.onlyForDistributor}
                        onChange={(e) => handleStatusChange(e, "applicable")}
                        className="input-checkbox"
                        disabled={true}
                      />
                      <label for="applicable" className="mb-0">
                        {values?.onlyForDistributor ? "Yes" : "No"}
                      </label>
                    </div>
                  </div>

                  {values?.id && (
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-3">
                      <label>
                        Status <span className="mandatory">*</span>
                      </label>
                      <div className="form-group mb-0">
                        <input
                          type="checkbox"
                          id="isActive"
                          name="isActive"
                          value={values?.isActive}
                          checked={values?.isActive}
                          onChange={(e) => handleStatusChange(e, "isActive")}
                          className="mr-2"
                          disabled={true}
                        />
                        <label htmlFor="isActive" className="mb-0">
                          {values?.isActive ? "Active" : "Inactive"}
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-3">
                    <label>View Cost Access</label>
                    <div className="form-group mb-0">
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        id="costing"
                        name="costing"
                        value={values?.canViewCosting}
                        checked={values?.canViewCosting}
                        onChange={(e) => handleStatusChange(e, "costing")}
                        className="mr-2"
                        disabled={true}
                      />
                      <label htmlFor="costing" className="mb-0">
                        Yes
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card role-permission-card">
              <div className="card-header">
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0">
                      <div className="header d-flex justify-content-start align-items-center w-100 flex-wrap">
                        <Link to="/role-management">
                          <button className="btn ml-3 p-0 mr-2" type="button">
                            <i class="fas fa-angle-left"></i>
                          </button>
                        </Link>
                        <h2>Role Permission</h2>
                      </div>
                    </div>
                  </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 mb-2 pr-3 pr-sm-3 pr-md-3">
                        <div className="card menu-card">
                          <div className="card-body">
                            <div
                              class="nav flex-column nav-pills"
                              id="v-pills-tab"
                              role="tablist"
                              aria-orientation="vertical"
                            >
                              <a class="nav-link menu-btn">Menu</a>
                              {parentMenuList?.length
                                ? parentMenuList?.map((itm, index) => (
                                  <>
                                    <a
                                      class="nav-link"
                                      id="v-pills-settings-tab"
                                      data-toggle="pill"
                                      href="#v-pills-settings"
                                      role="tab"
                                      aria-controls="v-pills-settings"
                                      aria-selected="false"
                                      onClick={() =>
                                        setSelectedParent(itm?.id)
                                      }
                                    >
                                      {itm?.menuName}
                                    </a>
                                  </>
                                ))
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-9 col-sm-8 col-xs-12 mb-2 pl-2">
                        <div class="tab-content" id="v-pills-tabContent">
                          <div
                            class="tab-pane fade show active"
                            id="v-pills-home"
                            role="tabpanel"
                            aria-labelledby="v-pills-home-tab"
                          >
                            <div className="role-view-table">
                              <table className="table table-striped table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="col">Sub Menu</th>
                                    <th scope="col" className="text-center">
                                      Add
                                    </th>
                                    <th scope="col" className="text-center">
                                      View
                                    </th>
                                    <th scope="col" className="text-center">
                                      Edit
                                    </th>
                                    <th scope="col" className="text-center">
                                      Delete
                                    </th>
                                    <th scope="col" className="text-center">
                                      Print
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {values?.rolePermissions?.length ? (
                                    values?.rolePermissions?.map(
                                      (itm, index) => (
                                        <tr key={index}>
                                          <td>{itm?.menuName}</td>
                                          <td>
                                            <div className="form-group pl-2 text-center">
                                              <input
                                                type="checkbox"
                                                style={{ cursor: "pointer" }}
                                                id="canAdd"
                                                name="canAdd"
                                                checked={itm?.canAdd}
                                                value={itm?.canAdd}
                                                onChange={(e) =>
                                                  handleCheck(e, index)
                                                }
                                                disabled={true}
                                              />
                                              <label for="add"></label>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group pl-0 text-center">
                                              <input
                                                type="checkbox"
                                                style={{ cursor: "pointer" }}
                                                id="canView"
                                                name="canView"
                                                value={itm?.canView}
                                                checked={itm?.canView}
                                                onChange={(e) =>
                                                  handleCheck(e, index)
                                                }
                                                disabled={true}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group pl-0 text-center">
                                              <input
                                                type="checkbox"
                                                style={{ cursor: "pointer" }}
                                                id="canEdit"
                                                name="canEdit"
                                                checked={itm?.canEdit}
                                                value={itm?.canEdit}
                                                onChange={(e) =>
                                                  handleCheck(e, index)
                                                }
                                                disabled={true}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group pl-0 text-center">
                                              <input
                                                type="checkbox"
                                                style={{ cursor: "pointer" }}
                                                id="canDelete"
                                                name="canDelete"
                                                checked={itm?.canDelete}
                                                value={itm?.canDelete}
                                                onChange={(e) =>
                                                  handleCheck(e, index)
                                                }
                                                disabled={true}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group pl-0 text-center">
                                              <input
                                                type="checkbox"
                                                style={{ cursor: "pointer" }}
                                                id="canPrint"
                                                name="canPrint"
                                                checked={itm?.canPrint}
                                                value={itm?.canPrint}
                                                onChange={(e) =>
                                                  handleCheck(e, index)
                                                }
                                                disabled={true}
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <p>No submenus available</p>
                                  )}
                                  {errors?.checked != "" && (
                                    <p className="form-error">
                                      {errors?.checked}
                                    </p>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>                  
            </div>
          </div>
        </div>
        <div className="row mt-3 mb-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right">
              <Link to="/role-management">
                <button className="btn back-btn" type="button">Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewRole;
